import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { selectUserRole } from '../store/auth/auth.selectors';
import { UserRoles } from '../constants/userRoles.constants';

@Injectable({
  providedIn: 'root'
})
export class OpoGuard implements CanActivate {
  private readonly roles = [
    UserRoles.Admin,
    UserRoles.FuneralHomeEmployee,
    UserRoles.OpoEmployee,
    UserRoles.ReferralUser
  ];
  constructor(private store: Store, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.store.select(selectUserRole).pipe(
      map(role => {
        if (role === UserRoles.OpoEmployee) return true;
        if(role === UserRoles.ReferralUser) return this.router.createUrlTree(['/referral/form']);
        return this.router.createUrlTree(['/donors']);
      })
    );
  }
}
